import { Outlet } from 'react-router-dom';

import { TransitioningHeader } from '../../../components/Header';
import { Menu } from '../../../components/Navigation';

import styles from './LayoutWithSidebar.module.css';

const LayoutWithSidebar: React.FC = () => {
  return (
    <div className={styles.layout}>
      <Menu />
      <main className={styles.body}>
        <TransitioningHeader />
        <div className={styles.content}>
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export { LayoutWithSidebar };
